
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M2.4 6.11c0-.683.554-1.237 1.236-1.237h24.728c.682 0 1.236.554 1.236 1.236v22.255c0 .682-.554 1.236-1.236 1.236H3.636A1.237 1.237 0 0 1 2.4 28.364V6.109zM6.11 2.4v3.71m4.945-3.71v3.71M16 2.4v3.71m4.945-3.71v3.71m4.946-3.71v3.71m-8.655 4.945h3.71V16H16v-3.71c0-.682.554-1.235 1.236-1.235zm3.71 0h3.709c.682 0 1.236.553 1.236 1.236V16h-4.946v-4.945zM16 20.945h4.945V16H16v4.945zm4.945 0h4.946V16h-4.946v4.945zM16 25.891h4.945v-4.946H16v4.946zm4.945-4.946h4.946v3.71c0 .682-.554 1.236-1.236 1.236h-3.71v-4.946zM7.345 16h3.71v4.945H6.109v-3.709c0-.682.554-1.236 1.236-1.236zm3.71 4.945H16V16h-4.945v4.945zm-4.946 0h4.946v4.946h-3.71a1.237 1.237 0 0 1-1.236-1.236v-3.71zm4.946 4.946H16v-4.946h-4.945v4.946z","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    